module.exports = __webpack_public_path__ + "static/media/Logo.bf2f54de.png";